(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('Composite', Composite);

    Composite.$inject = ['$resource'];

    function Composite ($resource) {
        var resourceUrl =  'api/composites/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
